export default __webpack_public_path__ + "static/media/north.aad26902.png";